import PropTypes from 'prop-types';

const CONFIGDATA = {
  primaryCertifier: PropTypes.bool,
  isComplete: PropTypes.bool,
  withESignature: PropTypes.bool,
};

export default CONFIGDATA;
